<template>
  <div class="mainBarMember1">
    <img class="logo" v-lazy-load :data-src="require('../../assets/logo.png')" alt="">
    <div class="block"></div>

    <!-- <div class="searchBox">
        <img src="../../assets/icon11-2.png" alt="">
        请输入内容
      </div> -->
    <div class="block"></div>
    <div class="leftBox">
      <div class="nav1">
        积分看板
        <img class="arrow" v-lazy-load :data-src="require('../../assets/arrow1-2.png')" alt="">
      </div>
      <div class="nav1 mgl">
        文件管理
        <img class="arrow" v-lazy-load :data-src="require('../../assets/arrow1-2.png')" alt="">
      </div>
      <div class="nav1 mgl">ESG评价改进</div>
      <div class="nav1 mgl">
        培训服务
        <img class="arrow" v-lazy-load :data-src="require('../../assets/arrow1-2.png')" alt="">
      </div>
      <div class="nav1 mgl">报告及证书</div>
      <div class="nav1 mgl">
        <img v-lazy-load :data-src="require('../../assets/icon13-2.png')" alt="" class="icon">
        {{ name || '姓名' }}
        <img class="arrow" v-lazy-load :data-src="require('../../assets/arrow1-2.png')" alt="">
      </div>
    </div>
  </div>
</template>

<script setup>
const name = localStorage.getItem('name')
</script>

<style scoped>
.mainBarMember1 {
  min-width: 1100px;
  max-width: 1980px;
  z-index: 9;
  width: 100%;
  height: 112px;
  background-color: #ffffff;
  box-shadow: 0px 4px 10.1px 0px rgba(0, 0, 0, 0.10);
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  top: 0;
  box-shadow: 0px 4px 10.1px 0px rgba(0, 0, 0, 0.1);
}

.mainBarMember1 .logo {
  width: max(min(7vw, 140px), 112px);
  height: max(min(5.01vw, 102px), 81.6px);
  margin-left: max(min(2.4vw, 48px), 30px);
}

.mainBarMember1 .leftBox {
  display: flex;
  flex-direction: row;
  margin-right: max(min(3vw, 60px), 35px);
  height: 100%;
  justify-content: space-around;
  /* border: 1px solid black; */
  align-items: center;
}

.mainBarMember1 .searchBox {
  width: max(min(18.5vw, 370px), 200px);
  height: 40px;
  border-radius: 4px;
  background-color: rgba(210, 210, 210, 0.25);
  display: flex;
  flex-direction: row;
  align-items: center;

  color: rgba(16, 38, 59, 0.25);
  font-size: 15px;
  font-weight: 400;
}

.mainBarMember1 .searchBox img {
  width: 16px;
  height: 16px;
  margin-left: 10px;
  margin-right: 10px;
  cursor: pointer;
}


.mainBarMember1 .leftBox .nav1 {
  font-size: 16px;
  color: #D2D2D2;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}

.mainBarMember1 .leftBox .mgl {
  margin-left: max(min(3.5vw, 70px), 30px);
}

.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  /* background-color: #ffc107; */
  z-index: 9;
  /* cursor: auto; */
}

.mainBarMember1 .leftBox .toast {
  position: absolute;
  width: 187px;
  height: 126px;
  top: 40px;
  z-index: 11;
  background-color: #fff;
  /* box-shadow: 2px ; */
  /* border: 1px solid black; */
  border-radius: 3px;
  box-shadow: 2px 5px 8px 0 rgba(82, 90, 102, 0.08);

  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.mainBarMember1 .leftBox .toast .content {
  color: #26734C;
  font-size: 14px;
  font-weight: 400;
  margin-left: 10px;
  cursor: pointer;
}

.mainBarMember1 .leftBox .icon {
  width: 24px;
  height: 24px;
  margin-right: 16px;
  /* border: 1px solid black; */
}

.mainBarMember1 .leftBox .arrow {
  width: 12px;
  height: 12px;
  margin-left: 10px;
}

.block {
  flex: 1;
}
</style>
